import React from "react";

import withSessionHandling, {
  type SessionHandlerProps,
} from "@/context/auth/withSessionHandling";
import DeleteAccountScreen from "@/screens/Settings/Security/DeleteAccountScreen";

function Page(props: SessionHandlerProps): React.JSX.Element {
  return <DeleteAccountScreen {...props} />;
}

export default withSessionHandling(Page);
